$(document).ready(function () {
	/* - - - - - - - - - - - - - -       header menu toggle       - - - - - - - - - - - - - - - */
	$(".js-header-menu-btn").on("click", function (e) {
		e.preventDefault();
		const $this = $(this);
		const $parent = $this.closest(".js-header-menu");
		if ($parent.hasClass("active")) {
			$parent.removeClass("active");
		} else {
			$parent.addClass("active");
		}
	});

	$(".js-header-menu").on("mouseover", function () {
		const $this = $(this);
		if (window.matchMedia("(min-width: 992px)").matches) {
			$this.addClass("active");
		}
	});
	$(".js-header-menu").on("mouseout", function () {
		const $this = $(this);
		if (window.matchMedia("(min-width: 992px)").matches) {
			$this.removeClass("active");
		}
	});

	/* - - - - - - - - - - - - - -       header navigation set       - - - - - - - - - - - - - - - */
	function setHeaderNavigation() {
		if ($(".js-header-navigation-block").is("*")) {
			const $this = $(".js-header-navigation-block");
			const $deskPlace = $(".js-header-navigation-desk");
			const $mobPlace = $(".js-header-navigation-mob");
			$this.detach();
			if (window.matchMedia("(max-width: 991px)").matches) {
				$mobPlace.append($this);
			} else {
				$deskPlace.append($this);
			}
		}
	}
	setHeaderNavigation();
	$(window).on("resize", function () {
		setHeaderNavigation();
	});

	/* - - - - - - - - - - - - - -       header top       - - - - - - - - - - - - - - - */
	function setHeaderTop() {
		// header
		const $header = $("#header");
		const headerHeight = $header.height();
		// preheader
		const $preheader = $("#preheader");
		const preheaderHeight = $preheader.height();
		// scroll value
		const scrollValue = window.pageYOffset;
		// main
		const $main = $("#main");
		$main.css("margin-top", headerHeight);
		// header catalog
		const $headerCatalog = $(".js-header-catalog");
		const $headerCatalogList = $(".js-header-catalog-block");
		// header Cart
		const $headerCart = $(".js-header-cart");
		const $headerCartHead = $(".js-header-cart-head");
		const $headerCartBody = $(".js-header-cart-body");
		const $headerCartFooter = $(".js-header-cart-footer");
		const $headerCartEmpty = $(".js-header-cart-empty");
		const headerCartHeadHeight = $headerCartHead.height();
		const headerCartFooterHeight = $headerCartFooter.height();
		// header Search
		const $headerSearch = $(".js-header-search");
		const $headerSearchBlock = $(".js-header-search-block");
		const $headerSearchContainer = $(".js-header-search-container");
		const headerSearchHeight = $headerSearch.height();

		const topWithPreheader =
			preheaderHeight - scrollValue > 0
				? preheaderHeight - scrollValue
				: 0;

		$header.css("top", topWithPreheader);
		$headerCatalog.css("top", topWithPreheader + headerHeight);

		if (window.matchMedia("(min-width: 992px)").matches) {
			$headerCatalogList.css(
				"max-height",
				`calc(100vh - ${topWithPreheader + headerHeight}px)`
			);
			// header cart
			$headerCart.css("top", topWithPreheader + headerHeight);
			$headerCartBody.css(
				"height",
				`calc(100vh - ${
					headerCartHeadHeight +
					headerCartFooterHeight +
					(topWithPreheader + headerHeight)
				}px)`
			);
			$headerCartEmpty.css(
				"height",
				`calc(100vh - ${
					headerCartHeadHeight + (topWithPreheader + headerHeight)
				}px)`
			);
			// header search
			$headerSearchBlock.css("top", topWithPreheader + headerHeight);
			$headerSearchContainer.css(
				"height",
				`calc(100vh - ${topWithPreheader + headerHeight}px)`
			);
		} else {
			$headerCatalogList.css("max-height", `none`);
			// mobile select
			$(".sort-modal").each(function () {
				const $this = $(this);
				$this.css("top", `${topWithPreheader + headerHeight}px`);
			});
			// mobile filter wrapper
			$(".filter-wrapper").each(function () {
				const $this = $(this);
				$this.css("top", `${topWithPreheader + headerHeight}px`);
			});
			// header cart
			$headerCart.css("top", 0);

			if (window.matchMedia("(min-width: 768px)").matches) {
				// header cart
				$headerCartBody.css(
					"height",
					`calc(100vh - ${
						headerCartHeadHeight + headerCartFooterHeight
					}px)`
				);
				$headerCartEmpty.css(
					"height",
					`calc(100vh - ${headerCartHeadHeight}px)`
				);
				// header search
				$headerSearchBlock.css(
					"top",
					`${topWithPreheader + headerHeight}px`
				);
				$headerSearchContainer.css(
					"height",
					`calc(100vh - ${topWithPreheader + headerHeight}px)`
				);
			} else {
				// header cart
				$headerCartBody.css(
					"height",
					`calc(100vh - ${
						headerCartHeadHeight + headerCartFooterHeight + 60
					}px)`
				);
				$headerCartEmpty.css(
					"height",
					`calc(100vh - ${headerCartHeadHeight + 60}px)`
				);
				// header search
				$headerSearchBlock.css("top", `${headerSearchHeight}px`);
				$headerSearchContainer.css(
					"height",
					`calc(100vh - ${headerSearchHeight}px)`
				);
			}
		}
	}
	setHeaderTop();
	window.addEventListener("scroll", function () {
		setHeaderTop();
	});
	window.addEventListener("resize", function () {
		setHeaderTop();
	});

	/* - - - - - - - - - - - - - -       hide header catalog menu toggle       - - - - - - - - - - - - - - - */
	$(".js-header-catalog-menu-toggle").on("click", function (e) {
		e.preventDefault();
		const $this = $(this);
		const $headerCatalogMenu = $(".js-header-catalog");
		if ($this.hasClass("active")) {
			$this.removeClass("active");
			$headerCatalogMenu.removeClass("show");
		} else {
			$this.addClass("active");
			$headerCatalogMenu.addClass("show");
		}
	});

	/* - - - - - - - - - - - - - -       header catalog menu item toggle       - - - - - - - - - - - - - - - */
	$(document).on("mouseover", "*", async function (e) {
		const $this = $(this);
		if (window.matchMedia("(min-width: 992px)").matches) {
			if ($this.closest(".js-catalog-item")) {
				await $(".js-catalog-item").removeClass("active");
				const $catalogItem = $this.closest(".js-catalog-item");
				$catalogItem.addClass("active");
				if ($this.closest(".js-catalog-item-subitem")) {
					await $(".js-catalog-item-subitem").removeClass("active");
					const $catalogItemSubitem = $this.closest(
						".js-catalog-item-subitem"
					);
					$catalogItemSubitem.addClass("active");
				}
			}
		}
	});

	$(document).on("mouseover", ".js-catalog-desk", function () {
		const $headerCatalogMenuBtn = $(".js-header-catalog-menu-toggle");
		const $headerCatalogMenu = $(".js-header-catalog");

		$headerCatalogMenuBtn.addClass("active");
		$headerCatalogMenu.addClass("show");
	});

	$(document).on("mouseout", ".js-catalog-desk", function () {
		const $headerCatalogMenuBtn = $(".js-header-catalog-menu-toggle");
		const $headerCatalogMenu = $(".js-header-catalog");

		$headerCatalogMenuBtn.removeClass("active");
		$headerCatalogMenu.removeClass("show");
	});

	/* - - - - - - - - - - - - - -       header mobile menu toggle       - - - - - - - - - - - - - - - */
	$(".js-header-mobile-menu-toggle").on("click", function (e) {
		e.preventDefault();
		const $header = $("#header");
		const $mobileMenu = $(".js-header-mobile-menu");
		const $help = $(".preheader-help");
		const $body = $("body");
		$help.removeClass("active");
		if ($mobileMenu.hasClass("active")) {
			$mobileMenu.removeClass("active");
			$header.css("z-index", 100);
			$body.css("overflow", "auto");
		} else {
			$mobileMenu.addClass("active");
			$header.css("z-index", 999);
			$body.css("overflow", "hidden");
		}
	});

	/* - - - - - - - - - - - - - -       header catalog set       - - - - - - - - - - - - - - - */
	function setHeaderCatalog() {
		if ($(".js-header-catalog-block").is("*")) {
			const $this = $(".js-header-catalog-block");
			const $deskPlace = $(".js-header-catalog-desk");
			const $mobPlace = $(".js-header-catalog-mob");
			$this.detach();
			if (window.matchMedia("(max-width: 991px)").matches) {
				$mobPlace.append($this);
			} else {
				$deskPlace.append($this);
			}
		}
	}
	setHeaderCatalog();
	$(window).on("resize", function () {
		setHeaderCatalog();
	});

	/* - - - - - - - - - - - - - -       header catalog submenu toggle       - - - - - - - - - - - - - - - */
	$(document).on("click", ".js-catalog-item-btn", function (e) {
		e.preventDefault();
		const $this = $(this);
		const $parent = $this.closest(".js-catalog-item");
		if (window.matchMedia("(max-width: 991px)").matches) {
			// if($parent.has) {
			$parent.toggleClass("active");
			// }
		}
	});

	/* - - - - - - - - - - - - - -       header comparer set       - - - - - - - - - - - - - - - */
	function setHeaderComparer() {
		if ($(".js-header-comparer-block").is("*")) {
			const $this = $(".js-header-comparer-block");
			const $deskPlace = $(".js-header-comparer-desk");
			const $mobPlace = $(".js-header-comparer-mob");
			$this.detach();
			if (window.matchMedia("(max-width: 991px)").matches) {
				$mobPlace.append($this);
			} else {
				$deskPlace.append($this);
			}
		}
	}
	setHeaderComparer();
	$(window).on("resize", function () {
		setHeaderComparer();
	});

	/* - - - - - - - - - - - - - -       init banner slider       - - - - - - - - - - - - - - - */
	$(".js-banner-slider").slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		speed: 600,
		cssEase: "linear",
		appendDots: ".js-banner-slider-dots",
	});

	/* - - - - - - - - - - - - - -       init collections slider       - - - - - - - - - - - - - - - */
	$(".js-collections-slider").slick({
		infinite: false,
		slidesToShow: 6,
		slidesToScroll: 1,
		rows: 2,
		arrows: false,
		dots: true,
		speed: 600,
		cssEase: "linear",
		responsive: [
			{
				breakpoint: 1240,
				settings: {
					slidesToShow: 5,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
		],
	});

	/* - - - - - - - - - - - - - -       match-height collections-box in slider       - - - - - - - - - - - - - - - */
	$(".js-collections-box").matchHeight({
		byRow: false,
		property: "height",
	});

	/* - - - - - - - - - - - - - -       init product slider       - - - - - - - - - - - - - - - */
	function initProductSlider() {
		if (window.matchMedia("(min-width: 992px)").matches) {
			$(".js-product-slider").slick({
				infinite: true,
				slidesToShow: 4,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				speed: 600,
				cssEase: "linear",
				responsive: [
					{
						breakpoint: 1240,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1,
						},
					},
				],
			});
		}
	}
	initProductSlider();
	$(window).resize(function () {
		if (
			$(".js-product-slider").hasClass("slick-initialized") &&
			window.matchMedia("(max-width: 991px)").matches
		) {
			$(".js-product-slider").slick("unslick");
		} else if (!$(".js-product-slider").hasClass("slick-initialized")) {
			initProductSlider();
		}
	});

	/* - - - - - - - - - - - - - -      product card menu toggle      - - - - - - - - - - - - - - - */
	$(".js-product-card-menu-toogle").on("click", function (e) {
		e.preventDefault();
		const $this = $(this);
		const $parent = $this.closest(".product-box__actions");
		$(".product-box__actions").removeClass("active");
		$parent.addClass("active");
	});

	$(document).on("click", "*", function (e) {
		const $target = e.target;
		const $actions = $(".product-box__actions");
		if (!$actions.is($target) && $actions.has($target).length === 0) {
			$actions.removeClass("active");
		}
	});

	/* - - - - - - - - - - - - - -      product card actions btn      - - - - - - - - - - - - - - - */
	$(".js-product-card-actions-btn").on("click", function (e) {
		e.preventDefault();
		const $this = $(this);
		if (!$this.hasClass("active")) {
			$this.addClass("active");
		} else {
			$this.removeClass("active");
		}
	});

	/* - - - - - - - - - - - - - -       init offers slider       - - - - - - - - - - - - - - - */
	$(".js-offers-slider").slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		speed: 600,
		cssEase: "linear",
	});

	/* - - - - - - - - - - - - - -       init banner slider       - - - - - - - - - - - - - - - */
	$(".js-main-slider").slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		speed: 600,
		cssEase: "linear",
		appendDots: ".js-main-slider-dots",
	});

	/* - - - - - - - - - - - - - -       init brands slider       - - - - - - - - - - - - - - - */
	$(".js-brands-slider").slick({
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		rows: 2,
		arrows: false,
		dots: true,
		speed: 600,
		cssEase: "linear",
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});

	/* - - - - - - - - - - - - - -       subscribe img set       - - - - - - - - - - - - - - - */
	function setSubscribeImg() {
		if ($(".js-subscribe-img-block").is("*")) {
			const $this = $(".js-subscribe-img-block");
			const $deskPlace = $(".js-subscribe-img-desk");
			const $mobPlace = $(".js-subscribe-img-mob");
			$this.detach();
			if (window.matchMedia("(max-width: 991px)").matches) {
				$mobPlace.append($this);
			} else {
				$deskPlace.append($this);
			}
		}
	}
	setSubscribeImg();
	$(window).on("resize", function () {
		setSubscribeImg();
	});

	/* - - - - - - - - - - - - - -       catalog tooltip       - - - - - - - - - - - - - - - */
	function catalogTooltip() {
		let tooltipElem;

		document.onmouseover = function (event) {
			const $target = event.target;
			const $actions = $("[data-catalog-tooltip]");
			if (window.matchMedia("(min-width: 992px)").matches) {
				if (
					!$actions.is($target) &&
					$actions.has($target).length === 0
				) {
					// For remove
					if (tooltipElem) {
						tooltipElem.remove();
						tooltipElem = null;
					}
				} else {
					// For create
					if (!tooltipElem) {
						tooltipElem = document.createElement("div");
					}
				}
				let target = event.target;

				let tooltipHtml = target.dataset.catalogTooltip;
				if (!tooltipHtml) return;

				tooltipElem.className = "tooltip";
				tooltipElem.innerHTML = tooltipHtml;
				$target.append(tooltipElem);

				// Positions
				let coords = target.getBoundingClientRect();
				let left = coords.left + coords.width - 200;
				if (left < 0) left = 0;

				let bottom = coords.bottom - 13;

				tooltipElem.style.left = left + "px";
				tooltipElem.style.top = bottom + "px";
			}
		};
	}
	catalogTooltip();

	/* - - - - - - - - - - - - - -      select adapter      - - - - - - - - - - - - - - - */
	$.fn.select2.amd.define(
		"CustomSelectionAdapter",
		[
			"select2/utils",
			"select2/selection/multiple",
			"select2/selection/placeholder",
			"select2/selection/eventRelay",
			"select2/selection/single",
		],
		function (
			Utils,
			MultipleSelection,
			Placeholder,
			EventRelay,
			SingleSelection
		) {
			// Decorates MultipleSelection with Placeholder
			let adapter = Utils.Decorate(MultipleSelection, Placeholder);
			// Decorates adapter with EventRelay - ensures events will continue to fire
			// e.g. selected, changed
			adapter = Utils.Decorate(adapter, EventRelay);

			adapter.prototype.render = function () {
				// Use selection-box from SingleSelection adapter
				// This implementation overrides the default implementation
				let $selection = SingleSelection.prototype.render.call(this);
				return $selection;
			};
			adapter.prototype.update = function (data) {
				// copy and modify SingleSelection adapter
				this.clear();
				let $rendered = this.$selection.find(
					".select2-selection__rendered"
				);
				let noItemsSelected = data.length === 0;
				let formatted = "";

				if (noItemsSelected) {
					formatted =
						this.options.get("placeholder") ||
						this.placeholder.text ||
						"";
				} else {
					let itemsData = {
						selected: data || [],
						all: this.$element.find("option") || [],
					};
					// Pass selected and all items to display method
					// which calls templateSelection
					formatted = this.display(itemsData, $rendered);
				}

				$rendered.empty().append(formatted);
				$rendered.prop("title", formatted);
			};

			return adapter;
		}
	);

	/* - - - - - - - - - - - - - -       catalog sort select      - - - - - - - - - - - - - - - */
	$(".js-sort-select").each(function () {
		const $this = $(this);
		$this.select2({
			width: "100%",
			minimumResultsForSearch: -1,
		});
	});

	/* - - - - - - - - - - - - - -      sort select selectTemplateResult     - - - - - - - - - - - - - - - */
	function selectTemplateResult(opt) {
		if (!opt.id) {
			return opt.text;
		}
		let optImage = $(opt.element).data("img");
		if (!optImage) {
			let $opt = $(
				`<div class="select2-results__option-custom ">
						<span>${opt.text}</span>
					</div>`
			);
			return $opt;
		} else {
			let $opt = $(
				`<div class="select2-results__option-custom select2-results__option__multi-img">
					<img src="${optImage}" />
					<span>${$(opt.element).text()}</span>
				</div>`
			);
			return $opt;
		}
	}
	/* - - - - - - - - - - - - - -       catalog sort select with modal on mobile and tablet     - - - - - - - - - - - - - - - */
	function initSortSelectModal() {
		$(".js-sort-select-modal").each(function () {
			const $this = $(this);
			const $parent = $this.closest(".sort");
			const $sortModalBody = $parent.find(".sort-modal__body");
			const $sortBtn = $parent.find(".sort-btn");
			if ($this.data("select2")) {
				$this.data("select2").destroy();
			}
			if (window.matchMedia("(min-width: 992px)").matches) {
				$this.select2({
					width: "100%",
					minimumResultsForSearch: -1,
					templateResult: selectTemplateResult,
					templateSelection: selectTemplateSelection,
					placeholder: $this[0].dataset.placeholder,
				});
			} else {
				$this.select2({
					width: "100%",
					minimumResultsForSearch: -1,
					templateResult: selectTemplateResult,
					templateSelection: selectTemplateSelection,

					placeholder: $this[0].dataset.placeholder,
					dropdownParent: $sortModalBody,
				});
			}

			function selectTemplateSelection(opt) {
				let result = `
				<div class="sort__result">
					<span class="sort__result-value">
						${opt.text}
					</span>
				</div>
			`;
				$sortBtn.html(result);
				return $(result);
			}

			$this.on("select2:open", function (e) {
				$parent.addClass("active");
			});
			$this.on("select2:close", function (e) {
				$parent.removeClass("active");
			});

			$sortBtn.on("click", function (e) {
				e.preventDefault();
				$this.select2("open");
			});
		});
	}
	initSortSelectModal();
	window.addEventListener("resize", function () {
		initSortSelectModal();
	});

	/* - - - - - - - - - - - - - -       init sort select multi && modal on mobile and tablet     - - - - - - - - - - - - - - - */
	function initSortSelectModalMulti() {
		$(".js-sort-select-modal-multi").each(function () {
			const $this = $(this);
			const $parent = $this.closest(".sort");
			const $sortModalBody = $parent.find(".sort-modal__body");

			if ($this.data("select2")) {
				$this.data("select2").destroy();
			}
			if (window.matchMedia("(min-width: 992px)").matches) {
				$this.select2({
					width: "100%",
					minimumResultsForSearch: -1,
					templateResult: selectTemplateResult,
					templateSelection: selectTemplateSelection,
					selectionAdapter: $.fn.select2.amd.require(
						"CustomSelectionAdapter"
					),
				});
			} else {
				$this.select2({
					width: "100%",
					minimumResultsForSearch: -1,
					templateResult: selectTemplateResult,
					templateSelection: selectTemplateSelection,
					selectionAdapter: $.fn.select2.amd.require(
						"CustomSelectionAdapter"
					),
					dropdownParent: $sortModalBody,
				});
			}

			function selectTemplateSelection(opt) {
				let result = `
				<div class="select2-selection-result">${$this[0].dataset.placeholder} ${
					opt.selected.length > 0 ? `(${opt.selected.length})` : ""
				}</div>`;
				return $(result);
			}

			$this.on("select2:select", function (e) {
				const $this = $(this);
				const val = $this.val();
				const placeholder = e.target.dataset.placeholder;
				const currentLenght = val.length;
				$this
					.closest(".sort-block")
					.find(
						".select2-selection__rendered"
					)[0].innerHTML = `<div class="select2-selection-result">${placeholder} ${
					currentLenght > 0 ? `(${currentLenght})` : ""
				}</div>`;
			});
			$this.on("select2:unselect", function (e) {
				let val = $this.val();
				const placeholder = e.target.dataset.placeholder;
				$this
					.closest(".sort-block")
					.find(
						".select2-selection__rendered"
					)[0].innerHTML = `<div class="select2-selection-result">${placeholder} ${
					val.length > 0 ? `(${val.length})` : ""
				}</div>`;
			});
			$this.on("select2:open", function (e) {
				$parent.addClass("active");
			});
			$this.on("select2:close", function (e) {
				$parent.removeClass("active");
			});
		});
	}
	initSortSelectModalMulti();
	window.addEventListener("resize", function () {
		initSortSelectModalMulti();
	});

	/* - - - - - - - - - - - - - -       catalog sort by select with modal on mobile and tablet     - - - - - - - - - - - - - - - */
	$(".js-sort-by-select").each(function () {
		const $this = $(this);
		const $parent = $this.closest(".sort");
		const $sortModalBody = $parent.find(".sort-modal__body");
		$this.select2({
			width: "100%",
			minimumResultsForSearch: -1,
			templateResult: selectTemplateResult,
			templateSelection: selectTemplateSelection,
			dropdownParent: $sortModalBody,
		});

		function selectTemplateSelection(opt) {
			if (!!opt.element.dataset.default && opt.element) {
				let $result = $(`
				<div class="sort-by__result">
					<i class="icon icon-i-sort-by"></i>
					<span class="sort-by__result-text">
						${opt.text}
					</span>
				</div>
			`);
				return $result;
			} else {
				let $result = $(`
					<div class="sort-by__result">
						<i class="icon icon-i-sort-by"></i>
						<span class="sort-by__result-text">
							${opt.text}
						</span>
						<div class="sort-by__result-remove js-sort-by-select-default">
							<i class="icon icon-i-close-circle "></i>
						</div>
					</div>
				`);
				return $result;
			}
		}

		$this.on("select2:open", function (e) {
			$parent.addClass("active");
		});
		$this.on("select2:close", function (e) {
			$parent.removeClass("active");
		});

		$(document).on("click", ".js-sort-by-select-default", function (e) {
			const defaultValue = $this.find("option[data-default='true']")[0]
				.value;
			$this.val(defaultValue).trigger("change").select2("close");
		});
	});

	/* - - - - - - - - - - - - - -       mobile and tablet btn for open catalog sort by select       - - - - - - - - - - - - - - - */
	$(".js-open-sort-by-select").on("click", function (e) {
		e.preventDefault();
		$(".js-sort-by-select").select2("open");
	});

	/* - - - - - - - - - - - - - -      filter-box toggle      - - - - - - - - - - - - - - - */
	$(document).on("click", ".js-filter-box-toggle", function (e) {
		e.preventDefault();
		const $this = $(this);
		const $parent = $this.closest(".filter-box");

		if (!$parent.hasClass("active")) {
			$parent.addClass("active");
		} else {
			$parent.removeClass("active");
		}
		catalogFilterPosition();
	});

	/* - - - - - - - - - - - - - -       prettify       - - - - - - - - - - - - - - - */
	function prettify(num) {
		const n = num.toString();
		return n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + " ");
	}

	/* - - - - - - - - - - - - - -      filter range      - - - - - - - - - - - - - - - */
	$(".js-range").each(function () {
		// let $parent =
		const $range = $(this),
			$parent = $range.closest(".range-box"),
			$inputFrom = $parent.find(".range-box__value-from"),
			$inputTo = $parent.find(".range-box__value-to"),
			min = parseInt($range.attr("data-min")),
			max = parseInt($range.attr("data-max")),
			valueFrom = parseInt($range.attr("data-from")),
			valueTo = parseInt($range.attr("data-to"));
		let instance;
		$range.ionRangeSlider({
			type: "double",
			grid: false,
			hide_from_to: true,
			hide_min_max: true,
			// min: min,
			// max: max,
			// from: valueFrom,
			// to: valueTo,
			onStart: updateInputsStart,
			onChange: updateInputs,
		});
		instance = $range.data("ionRangeSlider");
		function updateInputsStart(data) {
			const from = data.from,
				to = data.to;
			$inputFrom.prop("value", prettify(from));
			$inputTo.prop("value", prettify(to));
		}
		function updateInputs(data) {
			const from = data.from,
				to = data.to;
			$inputFrom.prop("value", prettify(from));
			$inputTo.prop("value", prettify(to));
			$parent.addClass("active");
		}
		$inputFrom.on("input", function () {
			let val = parseInt($(this).prop("value").replace(/\s+/g, ""));
			const to = parseInt(
				$(this)
					.closest(".range-box")
					.find(".range-box__value-to")
					.prop("value")
					.replace(/\s+/g, "")
			);
			// validate
			if (val <= min) {
				val = min;
			} else if (val >= to) {
				val = to;
			}
			instance.update({
				from: val,
			});
			$parent.addClass("active");
			// $inputFrom.val( prettify( val ) );
		});
		$inputFrom.on("blur", function () {
			let val = parseInt($(this).prop("value").replace(/\s+/g, ""));
			const to = parseInt(
				$(this)
					.closest(".range-box")
					.find(".range-box__value-to")
					.prop("value")
					.replace(/\s+/g, "")
			);
			if (val <= min || !val) {
				val = min;
			} else if (val >= to) {
				val = to;
			}
			$inputFrom.val(prettify(val));
		});
		$inputTo.on("input", function () {
			let val = parseInt($(this).prop("value").replace(/\s+/g, ""));
			const from = parseInt(
				$(this)
					.closest(".range-box")
					.find(".range-box__value-from")
					.prop("value")
					.replace(/\s+/g, "")
			);
			// validate
			if (val < from) {
				val = from;
			} else if (val > max) {
				val = max;
			}
			instance.update({
				to: val,
			});
			$parent.addClass("active");
			// $inputTo.val( prettify( val ) );
		});
		$inputTo.on("blur", function () {
			let val = parseInt($(this).prop("value").replace(/\s+/g, ""));
			const from = parseInt(
				$(this)
					.closest(".range-box")
					.find(".range-box__value-from")
					.prop("value")
					.replace(/\s+/g, "")
			);
			if (val >= max || !val) {
				val = max;
			} else if (val <= from) {
				val = from;
			}
			$inputTo.val(prettify(val));
		});
	});

	/* - - - - - - - - - - - - - -      catalog filter toogle     - - - - - - - - - - - - - - - */
	$(".js-catalog-filter-toggle").on("click", function (e) {
		e.preventDefault();
		const $filter = $(".js-catalog-filter");
		if ($filter.hasClass("active")) {
			$filter.removeClass("active");
		} else {
			$filter.addClass("active");
		}
	});

	/* - - - - - - - - - - - - - -      accordion toogle     - - - - - - - - - - - - - - - */
	$(".js-accordion-btn").on("click", function (e) {
		e.preventDefault();
		const $this = $(this);
		const $parent = $this.closest(".js-accordion-box");
		if ($parent.hasClass("active")) {
			$parent.removeClass("active");
		} else {
			$parent.addClass("active");
		}
	});

	/* - - - - - - - - - - - - - -      catalog filter position     - - - - - - - - - - - - - - - */
	function catalogFilterPosition() {
		const $filter = $(".js-catalog-product-filter");
		const $filterWrapper = $(".js-catalog-product-filter-wrapper");
		const $catalog = $(".js-catalog-product-list");
		const scrollValue = window.pageYOffset;
		const $header = $("#header");
		const headerHeight = $header.height();
		const windowHeight = document.documentElement.clientHeight;
		if ($filter.is("*") && $catalog.is("*")) {
			if (window.matchMedia("(min-width: 992px)").matches) {
				let filterRect = $filter[0].getBoundingClientRect();
				let catalogRect = $catalog[0].getBoundingClientRect();
				let filterWrapperRect =
					$filterWrapper[0].getBoundingClientRect();

				$filterWrapper.css("width", `${$filter.css("width")}`);
				if (filterRect.y - headerHeight < 0) {
					$filterWrapper.css("position", "fixed");
					$filterWrapper.css("left", `${filterRect.left}px`);
					if (
						filterWrapperRect.bottom < catalogRect.bottom &&
						catalogRect.height -
							Math.abs(catalogRect.top) -
							windowHeight >
							0 &&
						filterWrapperRect.bottom + headerHeight + 20 <
							catalogRect.bottom
					) {
						$filterWrapper.css("top", `${headerHeight + 20}px`);
						$filterWrapper.css("bottom", `auto`);
					} else if (
						filterWrapperRect.top >= headerHeight + 20 &&
						filterWrapperRect.height + headerHeight + 20 <
							catalogRect.bottom
					) {
						$filterWrapper.css("top", `${headerHeight + 20}px`);
						$filterWrapper.css("bottom", `auto`);
					} else {
						$filterWrapper.css("top", `auto`);
						$filterWrapper.css(
							"bottom",
							`${-(
								catalogRect.height -
								Math.abs(catalogRect.top) -
								windowHeight
							)}px`
						);
					}
				} else {
					$filterWrapper.css("position", "static");
					$filterWrapper.css("left", `0px`);
					$filterWrapper.css("top", `0`);
					$filterWrapper.css("width", `100%`);
				}
			} else {
				$filterWrapper.css("position", "static");
				$filterWrapper.css("left", `auto`);
				$filterWrapper.css("top", `auto`);
				$filterWrapper.css("bottom", `auto`);
				$filterWrapper.css("width", `100%`);
			}
		}
	}
	catalogFilterPosition();
	window.addEventListener("scroll", function () {
		catalogFilterPosition();
	});
	window.addEventListener("resize", function () {
		catalogFilterPosition();
	});

	/* - - - - - - - - - - - - - -       custom scroll axis X     - - - - - - - - - - - - - - - */
	$(".custom-scroll-x").each(function () {
		const $this = $(this);

		$this.mCustomScrollbar({
			axis: "x",
			theme: "dark",
			documentTouchScroll: true,
		});
	});

	/* - - - - - - - - - - - - - -       custom scroll axis Y     - - - - - - - - - - - - - - - */
	$(".custom-scroll-y").each(function () {
		const $this = $(this);

		$this.mCustomScrollbar({
			axis: "y",
			theme: "dark",
			documentTouchScroll: true,
		});
	});

	/* - - - - - - - - - - - - - -      product card slider        - - - - - - - - - - - - - - - */
	$(".js-product-img-slider").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		// fade: true,
		dots: false,
		arrows: false,
		asNavFor: ".js-product-img-preview-slider",
		responsive: [
			{
				breakpoint: 992,
				settings: {
					arrows: true,
					dots: true,
				},
			},
		],
	});

	$(".js-product-img-preview-slider").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		asNavFor: ".js-product-img-slider",
		arrows: true,
		dots: false,
		vertical: true,
		focusOnSelect: true,
	});

	/* - - - - - - - - - - - - - -       counter block      - - - - - - - - - - - - - - - */
	$(".js-counter").on("click", function (e) {
		e.preventDefault();
		const $target = $(e.target);
		const $parent = $target.closest(".counter");
		let $counter = $parent.find(`[data-context='counter']`);
		let $minus = $parent.find(`[data-context='minus']`);
		let $counterValue = $counter.html().trim();
		let $targetData = $target.data("context");
		if (!$targetData) {
			$targetData = $target.parent().data("context");
		}
		if ($targetData == "minus") {
			if (Number($counterValue) > 1) {
				$counter.html(`${Number($counterValue) - 1}`);
				if ($counterValue - 1 <= 1) {
					$minus.addClass("disable");
				}
			}
		} else if ($targetData == "plus") {
			$counter.html(`${Number($counterValue) + 1}`);
			if ($counterValue + 1 >= 1 && $minus.hasClass("disable")) {
				$minus.removeClass("disable");
			}
		}
	});
	function checkIfMinusDissable() {
		let $counter = $(`[data-context='counter']`);
		if ($counter.is("*")) {
			$counter.each(function () {
				const $this = $(this);
				const $minus = $this.siblings("[data-context='minus']");
				if (Number($this.html().trim()) <= 1) {
					$minus.addClass("disable");
				}
			});
		}
	}
	checkIfMinusDissable();

	/* - - - - - - - - - - - - - -       product characteristis select with modal on mobile and tablet     - - - - - - - - - - - - - - - */
	$(".js-product-characteristics-select").each(function () {
		const $this = $(this);
		const $parent = $this.closest(".sort");
		const $sortModalBody = $parent.find(".sort-modal__body");
		const $sortBtn = $parent.find(".sort-btn");
		$this.select2({
			width: "100%",
			minimumResultsForSearch: -1,
			templateResult: selectTemplateResult,
			templateSelection: selectTemplateSelection,
			dropdownParent: $sortModalBody,
		});

		function selectTemplateSelection(opt) {
			let result = `
			<div class="sort-product__characteristics__result">
				<span class="sort-product__characteristics__result-placeholder">
					${$this[0].dataset.placeholder}
				</span>	
				<span class="sort-product__characteristics__result-value">
					${opt.text}
				</span>
			</div>
		`;
			$sortBtn.html(result);
			return $(result);
		}

		$this.on("select2:open", function (e) {
			$parent.addClass("active");
		});
		$this.on("select2:close", function (e) {
			$parent.removeClass("active");
		});

		$sortBtn.on("click", function (e) {
			e.preventDefault();
			$this.select2("open");
		});
	});

	/* - - - - - - - - - - - - - -      product slider position     - - - - - - - - - - - - - - - */
	function ProductSliderPosition() {
		const $productHead = $(".js-head-product");
		const $productHeadWrapper = $(".js-head-product-wrapper");
		const $productBody = $(".js-body-product");
		const scrollValue = window.pageYOffset;
		const $header = $("#header");
		const headerHeight = $header.height();
		const windowHeight = document.documentElement.clientHeight;
		if ($productHead.is("*") && $productBody.is("*")) {
			if (window.matchMedia("(min-width: 992px)").matches) {
				const productHeadRect = $productHead[0].getBoundingClientRect();
				const productBodyRect = $productBody[0].getBoundingClientRect();
				const productHeadWrapperRect =
					$productHeadWrapper[0].getBoundingClientRect();

				$productHeadWrapper.css(
					"width",
					`${$productHead.css("width")}`
				);
				if (productHeadRect.y - headerHeight < 0) {
					$productHeadWrapper.css("position", "fixed");
					$productHeadWrapper.css(
						"left",
						`${productHeadRect.left}px`
					);
					if (
						productHeadWrapperRect.bottom <
							productBodyRect.bottom &&
						productBodyRect.height -
							Math.abs(productBodyRect.top) -
							windowHeight >
							0 &&
						productHeadWrapperRect.bottom + headerHeight <
							productBodyRect.bottom
					) {
						$productHeadWrapper.css("top", `${headerHeight}px`);
						$productHeadWrapper.css("bottom", `auto`);
					} else if (
						productHeadWrapperRect.top >= headerHeight &&
						productHeadWrapperRect.height + headerHeight <
							productBodyRect.bottom
					) {
						$productHeadWrapper.css("top", `${headerHeight}px`);
						$productHeadWrapper.css("bottom", `auto`);
					} else {
						$productHeadWrapper.css("top", `auto`);
						$productHeadWrapper.css(
							"bottom",
							`${-(
								productBodyRect.height -
								Math.abs(productBodyRect.top) -
								windowHeight
							)}px`
						);
					}
				} else {
					$productHeadWrapper.css("position", "relative");
					$productHeadWrapper.css("left", `0px`);
					$productHeadWrapper.css("top", `0`);
					$productHeadWrapper.css("width", `100%`);
				}
			} else {
				$productHeadWrapper.css("width", `100%`);
				$productHeadWrapper.css("position", "relative");
				$productHeadWrapper.css("left", `auto`);
				$productHeadWrapper.css("top", `auto`);
				$productHeadWrapper.css("bottom", `auto`);
			}
		}
	}
	ProductSliderPosition();
	window.addEventListener("scroll", function () {
		ProductSliderPosition();
	});
	window.addEventListener("resize", function () {
		ProductSliderPosition();
	});

	/* - - - - - - - - - - - - - -     product fixed show     - - - - - - - - - - - - - - - */
	function ProductFixedShow() {
		const $productFixed = $(".js-product-fixed");
		const $productPrice = $(".js-proudct-price");
		const $header = $("#header");
		const headerHeight = $header.height();

		if ($productFixed.is("*") && $productPrice.is("*")) {
			const productPriceRect = $productPrice[0].getBoundingClientRect();

			if (productPriceRect.bottom - headerHeight < 0) {
				$productFixed.addClass("show");
			} else {
				$productFixed.removeClass("show");
			}
			if (window.matchMedia("(min-width: 992px)").matches) {
				$productFixed.css("top", `${headerHeight}px`);
			} else {
				$productFixed.css("top", `auto`);
			}
		}
	}
	ProductFixedShow();
	window.addEventListener("scroll", function () {
		ProductFixedShow();
	});
	window.addEventListener("resize", function () {
		ProductFixedShow();
	});

	/* - - - - - - - - - - - - - -      product info set       - - - - - - - - - - - - - - - */
	function setProductInfo() {
		if ($(".js-product-info-block").is("*")) {
			const $this = $(".js-product-info-block");
			const $deskPlace = $(".js-product-info-desk");
			const $mobPlace = $(".js-product-info-mob");
			$this.detach();
			if (window.matchMedia("(max-width: 991px)").matches) {
				$mobPlace.append($this);
			} else {
				$deskPlace.append($this);
			}
		}
	}
	setProductInfo();
	$(window).on("resize", function () {
		setProductInfo();
	});

	/* - - - - - - - - - - - - - -      product actions set       - - - - - - - - - - - - - - - */
	function setProductActions() {
		if ($(".js-proudct-actions-block").is("*")) {
			const $this = $(".js-proudct-actions-block");
			const $deskPlace = $(".js-proudct-actions-desk");
			const $tabletPlace = $(".js-proudct-actions-tablet");
			const $mobPlace = $(".js-proudct-actions-mob");
			$this.detach();
			if (window.matchMedia("(min-width: 992px)").matches) {
				$deskPlace.append($this);
			} else if (window.matchMedia("(min-width: 768px)").matches) {
				$tabletPlace.append($this);
			} else {
				$mobPlace.append($this);
			}
		}
	}
	setProductActions();
	$(window).on("resize", function () {
		setProductActions();
	});

	/* - - - - - - - - - - - - - -       header cart toggle       - - - - - - - - - - - - - - - */
	$(".js-header-cart-toggle").on("click", function (e) {
		e.preventDefault();
		const $headerCart = $(".js-header-cart");
		const $preheader = $("#preheader");
		const $body = $("body");
		if (!$headerCart.hasClass("active")) {
			$headerCart.addClass("active");
			$preheader.css("z-index", 99);
			$body.css("overflow", "hidden");
		} else {
			$headerCart.removeClass("active");
			$preheader.css("z-index", 101);
			$body.css("overflow", "auto");
		}
	});

	/* - - - - - - - - - - - - - -       header cart position       - - - - - - - - - - - - - - - */
	const headerCartPosition = function () {
		const $headerCartHead = $(".js-header-cart-head");
		const $headerCartBody = $(".js-header-cart-body");
		const $headerCartFooter = $(".js-header-cart-footer");
		const $headerCartEmpty = $(".js-header-cart-empty");
		const conatinerWidth = $(".container").css("max-width");

		const $headerCartHeadInner = $headerCartHead.find(
			".header-cart__head__inner"
		);
		const $headerCartBox = $headerCartBody.find(".header-cart__box");
		const $headerCartFooterInner = $headerCartFooter.find(
			".header-cart__footer__inner"
		);
		const $headerCartEmptyInner = $headerCartEmpty.find(
			".header-cart__empty__inner"
		);

		const maxWidth =
			528 +
			(document.documentElement.clientWidth -
				conatinerWidth.slice(0, conatinerWidth.length - 2)) /
				2 +
			40;

		const paddingRight =
			(document.documentElement.clientWidth -
				conatinerWidth.slice(0, conatinerWidth.length - 2)) /
			2;

		if (window.matchMedia("(min-width: 768px)").matches) {
			$headerCartHeadInner.css("width", `${maxWidth}px`);
			$headerCartHeadInner.css("padding-left", "40px");
			$headerCartHeadInner.css("padding-right", `${paddingRight}px`);
			$headerCartFooterInner.css("width", `${maxWidth}`);
			$headerCartFooterInner.css("padding-left", "40px");
			$headerCartFooterInner.css("padding-right", `${paddingRight}px`);
			$headerCartBox.css("width", `${maxWidth}`);
			$headerCartBox.css("padding-left", "40px");
			$headerCartBox.css("padding-right", `${paddingRight}px`);
			$headerCartEmptyInner.css("padding-left", "150px");
			$headerCartEmptyInner.css(
				"padding-right",
				`${paddingRight + 87}px`
			);
		} else {
			$headerCartHeadInner.css("width", "100%");
			$headerCartHeadInner.css("padding-left", "24px");
			$headerCartHeadInner.css("padding-right", "24px");
			$headerCartFooterInner.css("width", "100%");
			$headerCartFooterInner.css("padding-left", "24px");
			$headerCartFooterInner.css("padding-right", "24px");
			$headerCartBox.css("width", `100%`);
			$headerCartBox.css("padding-left", "24px");
			$headerCartBox.css("padding-right", "24px");
			$headerCartEmptyInner.css("padding-left", "24px");
			$headerCartEmptyInner.css("padding-right", "24px");
		}
	};
	headerCartPosition();
	window.addEventListener("resize", function () {
		headerCartPosition();
	});

	/* - - - - - - - - - - - - - -       header search open       - - - - - - - - - - - - - - - */
	$(".js-header-search-open").on("click", function (e) {
		e.preventDefault();
		const $header = $("#header");
		const $headerSearchBlock = $(".js-header-search-block");
		const $headerSearch = $(".js-header-search");
		const $headerSearchInput = $(".js-header-search-input");
		const $headerSearchOverlay = $(".js-header-search-overlay");
		const $body = $("body");
		if (!$headerSearchBlock.hasClass("active")) {
			$headerSearchBlock.addClass("active");
			$headerSearch.addClass("active");
			$headerSearchInput.val("").trigger("change");
			$headerSearchOverlay.addClass("active");
			$header.css("z-index", 999);
			$body.css("overflow", "hidden");
		}
	});

	/* - - - - - - - - - - - - - -       header search close       - - - - - - - - - - - - - - - */
	$(".js-header-search-close").on("click", function (e) {
		e.preventDefault();
		const $header = $("#header");
		const $headerSearchBlock = $(".js-header-search-block");
		const $headerSearch = $(".js-header-search");
		const $headerSearchInput = $(".js-header-search-input");
		const $headerSearchOverlay = $(".js-header-search-overlay");
		const $body = $("body");
		if ($headerSearchBlock.hasClass("active")) {
			$headerSearchBlock.removeClass("active");
			$headerSearch.removeClass("active");
			$headerSearchInput.val("").trigger("change");
			$headerSearchOverlay.removeClass("active");
			$header.css("z-index", 100);
			$body.css("overflow", "auto");
		}
	});

	/* - - - - - - - - - - - - - -       header search input       - - - - - - - - - - - - - - - */
	$(".js-header-search-input").on("change paste keyup input", function () {
		const $this = $(this);
		const $headerSearch = $(".js-header-search");
		const $headerSeacrhInfo = $(".js-header-search-info");
		const $headerSearchClear = $(".js-header-search-clear");
		const $headerSearchInputBuffer = $(".js-header-search-input-buffer");
		const $headerSearchNothing = $(".js-header-search-nothing");
		$headerSearchInputBuffer.text($this.val());
		$headerSearchNothing.text(`"${$this.val()}"`);
		if ($this.val()) {
			$this.width($headerSearchInputBuffer.width() + 30);
			$headerSeacrhInfo.addClass("show-result");
			$headerSearchClear.addClass("show");
		} else {
			if ($headerSearch.hasClass("active")) {
				$this.css("width", "auto");
			} else {
				$this.css("width", "100%");
			}
			$headerSeacrhInfo.removeClass("show-result");
			$headerSearchClear.removeClass("show");
		}
	});

	/* - - - - - - - - - - - - - -       clear header search input       - - - - - - - - - - - - - - - */
	$(".js-header-search-clear").on("click", function (e) {
		e.preventDefault();
		const $headerSearchInput = $(".js-header-search-input");
		$headerSearchInput.val("").trigger("change");
	});

	/* - - - - - - - - - - - - - -       show password       - - - - - - - - - - - - - - - */
	$(".js-password-btn").on("click", function (e) {
		e.preventDefault();
		const $this = $(this);
		const $block = $this.closest(".js-password-block");
		const $input = $this.siblings(".js-password-input");
		console.log($input.attr("type"));
		if ($input.attr("type") !== "password") {
			$block.removeClass("show");
			$input.attr("type", "password");
		} else {
			$block.addClass("show");
			$input.attr("type", "text");
		}
	});

	/* - - - - - - - - - - - - - -       show succes recover sent instruction      - - - - - - - - - - - - - - - */
	$(".js-recovery-btn").on("click", function () {
		const $recoveryForm = $(".js-recovery-form");
		const $recoverySuccess = $(".js-recovery-success");
		$recoveryForm.addClass("d-none");
		$recoverySuccess.removeClass("d-none");
	});

	/* - - - - - - - - - - - - - -       product-box view prevent default      - - - - - - - - - - - - - - - */
	$(".product-box__img-view").on("click", function (e) {
		e.preventDefault();
		$(".js-product-img-preview-slider").resize();
	});

	/* - - - - - - - - - - - - - -      product view slider        - - - - - - - - - - - - - - - */
	$(".js-product-view-img-slider").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		// fade: true,
		dots: false,
		arrows: false,
		asNavFor: ".js-product-view-img-preview-slider",
	});

	$(".js-product-view-img-preview-slider").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		asNavFor: ".js-product-view-img-slider",
		arrows: false,
		dots: false,
		vertical: true,
		focusOnSelect: true,
	});

	/* - - - - - - - - - - - - - -      product view slider refresh       - - - - - - - - - - - - - - - */
	$(".product-view").on("shown.bs.modal", function () {
		$(".js-product-view-img-slider").slick("refresh");
		$(".js-product-view-img-preview-slider").slick("refresh");
	});

	/* - - - - - - - - - - - - - -      our story bg position     - - - - - - - - - - - - - - - */
	function OurStoryBgPosition() {
		const $ourStoryBg = $(".js-our-story-bg");
		const $ourStoryMain = $(".js-our-story-main");
		const $ourStoryBack = $(".js-our-story-back");
		const $header = $("#header");
		const headerHeight = $header.height();
		const windowHeight = document.documentElement.clientHeight;
		const scrollValue = window.pageYOffset;
		const $preheader = $("#preheader");
		const preheaderHeight = $preheader.height();
		const topWithPreheader =
			preheaderHeight - scrollValue > 0
				? preheaderHeight - scrollValue
				: 0;

		if ($ourStoryBg.is("*") && $ourStoryMain.is("*")) {
			$ourStoryBg.css("top", `${topWithPreheader + headerHeight}px`);
			if (window.matchMedia("(min-width: 768px)").matches) {
				const ourStoryBgRect = $ourStoryBg[0].getBoundingClientRect();
				const ourStoryMainRect =
					$ourStoryMain[0].getBoundingClientRect();

				if (ourStoryMainRect.y - headerHeight < 0) {
					if (ourStoryBgRect.bottom < ourStoryMainRect.bottom) {
						$ourStoryBg.css(
							"top",
							`${topWithPreheader + headerHeight}px`
						);
					} else {
						$ourStoryBg.css("top", `auto`);
						$ourStoryBg.css(
							"bottom",
							`${-(
								ourStoryMainRect.height -
								Math.abs(ourStoryMainRect.top) -
								windowHeight
							)}px`
						);
					}
				}
			} else {
				// $productHeadWrapper.css("position", "relative");
				// $productHeadWrapper.css("left", `0px`);
				// $productHeadWrapper.css("top", `0`);
				// $productHeadWrapper.css("width", `100%`);
			}
		}
		if ($ourStoryBack.is("*") && $ourStoryMain.is("*")) {
			if (window.matchMedia("(min-width: 992px)").matches) {
				const ourStoryMainRect =
					$ourStoryMain[0].getBoundingClientRect();
				const ourStoryBackRect =
					$ourStoryBack[0].getBoundingClientRect();

				if (ourStoryMainRect.y - headerHeight < 0) {
					$ourStoryBack.css("position", "fixed");
					$ourStoryBack.css(
						"top",
						`${topWithPreheader + headerHeight}px`
					);
					if (ourStoryBackRect.bottom < ourStoryMainRect.bottom) {
						$ourStoryBack.css(
							"top",
							`${topWithPreheader + headerHeight}px`
						);
					} else {
						$ourStoryBack.css("top", `auto`);
						$ourStoryBack.css(
							"bottom",
							`${-(
								ourStoryMainRect.height -
								Math.abs(ourStoryMainRect.top) -
								windowHeight
							)}px`
						);
					}
				} else {
					$ourStoryBack.css("position", "static");
				}
			} else {
				$ourStoryBack.css("position", "static");
			}
		}
	}

	OurStoryBgPosition();
	window.addEventListener("scroll", function () {
		OurStoryBgPosition();
	});
	window.addEventListener("resize", function () {
		OurStoryBgPosition();
	});

	/* - - - - - - - - - - - - - -      faq nav position     - - - - - - - - - - - - - - - */
	function FaqNavPosition() {
		const $nav = $(".js-faq-nav");
		const $navWrapper = $(".js-faq-nav-wrapper");
		const $info = $(".js-faq-info");
		const scrollValue = window.pageYOffset;
		const $header = $("#header");
		const headerHeight = $header.height();
		const windowHeight = document.documentElement.clientHeight;
		if ($nav.is("*") && $info.is("*")) {
			if (window.matchMedia("(min-width: 992px)").matches) {
				let navRect = $nav[0].getBoundingClientRect();
				let infoRect = $info[0].getBoundingClientRect();
				let navWrapperRect = $navWrapper[0].getBoundingClientRect();

				$navWrapper.css("width", `${$nav.css("width")}`);
				if (navRect.y - headerHeight < 0) {
					$navWrapper.css("position", "fixed");
					$navWrapper.css("left", `${navRect.left}px`);
					if (
						navWrapperRect.bottom < infoRect.bottom &&
						infoRect.height -
							Math.abs(infoRect.top) -
							windowHeight >
							0 &&
						navWrapperRect.bottom + headerHeight + 20 <
							infoRect.bottom
					) {
						$navWrapper.css("top", `${headerHeight + 20}px`);
						$navWrapper.css("bottom", `auto`);
					} else if (
						navWrapperRect.top >= headerHeight + 20 &&
						navWrapperRect.height + headerHeight + 20 <
							infoRect.bottom
					) {
						$navWrapper.css("top", `${headerHeight + 20}px`);
						$navWrapper.css("bottom", `auto`);
					} else {
						$navWrapper.css("top", `auto`);
						$navWrapper.css(
							"bottom",
							`${-(
								infoRect.height -
								Math.abs(infoRect.top) -
								windowHeight
							)}px`
						);
					}
				} else {
					$navWrapper.css("position", "static");
					$navWrapper.css("left", `0px`);
					$navWrapper.css("top", `0`);
					$navWrapper.css("width", `100%`);
				}
			} else {
				$navWrapper.css("position", "static");
				$navWrapper.css("left", `auto`);
				$navWrapper.css("top", `auto`);
				$navWrapper.css("bottom", `auto`);
				$navWrapper.css("width", `100%`);
			}
		}
	}
	FaqNavPosition();
	window.addEventListener("scroll", function () {
		FaqNavPosition();
	});
	window.addEventListener("resize", function () {
		FaqNavPosition();
	});

	/* - - - - - - - - - - - - - -      anchor     - - - - - - - - - - - - - - - */
	$("[data-anchor-target]").on("click", function (e) {
		e.preventDefault();
		const $this = $(this);
		const anchorTargetValue = $this.data("anchor-target");
		let $anchorTarget = null;
		const $header = $("#header");
		const headerHeight = $header.height();
		$("[data-anchor-block]").each(function () {
			const $thisBlock = $(this);
			if ($thisBlock.data("anchor-block") === anchorTargetValue) {
				$anchorTarget = $thisBlock;
			}
		});
		if ($anchorTarget) {
			$("[data-anchor-target]").removeClass("active");
			$this.addClass("active");
			$([document.documentElement, document.body]).animate(
				{
					scrollTop: $anchorTarget.offset().top - headerHeight - 20,
				},
				1000
			);
		}
	});

	/* - - - - - - - - - - - - - -       faq breadcrumbs set       - - - - - - - - - - - - - - - */
	function setFaqBreadcrumbs() {
		if ($(".js-faq-breadcrumbs-block").is("*")) {
			const $this = $(".js-faq-breadcrumbs-block");
			const $deskPlace = $(".js-faq-breadcrumbs-desk");
			const $mobPlace = $(".js-faq-breadcrumbs-mob");
			$this.detach();
			if (window.matchMedia("(max-width: 991px)").matches) {
				$mobPlace.append($this);
			} else {
				$deskPlace.append($this);
			}
		}
	}
	setFaqBreadcrumbs();
	$(window).on("resize", function () {
		setFaqBreadcrumbs();
	});

	/* - - - - - - - - - - - - - -       faq title set       - - - - - - - - - - - - - - - */
	function setFaqTitle() {
		if ($(".js-faq-title-block").is("*")) {
			const $this = $(".js-faq-title-block");
			const $deskPlace = $(".js-faq-title-desk");
			const $mobPlace = $(".js-faq-title-mob");
			$this.detach();
			if (window.matchMedia("(max-width: 991px)").matches) {
				$mobPlace.append($this);
			} else {
				$deskPlace.append($this);
			}
		}
	}
	setFaqTitle();
	$(window).on("resize", function () {
		setFaqTitle();
	});

	/* - - - - - - - - - - - - - -       faq search input       - - - - - - - - - - - - - - - */
	$(".js-faq-search-input").on("change paste keyup input", function () {
		const $this = $(this);
		const $faqSearch = $(".js-faq-search");
		const $faqSeacrhInfo = $(".js-faq-search-info");
		const $faqSearchClear = $(".js-faq-search-clear");
		const $faqSearchInputBuffer = $(".js-faq-search-input-buffer");
		const $faqSearchNothing = $(".js-faq-search-nothing");
		const $faqSearchClose = $(".js-faq-search-close");

		$faqSearchInputBuffer.text($this.val());
		$faqSearchNothing.text(`"${$this.val()}"`);
		if ($this.val()) {
			$this.width($faqSearchInputBuffer.width() + 30);
			$faqSeacrhInfo.addClass("show-result");
			$faqSearchClear.addClass("show");
			$faqSearchClose.addClass("show");
		} else {
			if ($faqSearch.hasClass("active")) {
				$this.css("width", "auto");
			} else {
				$this.css("width", "100%");
			}
			$faqSeacrhInfo.removeClass("show-result");
			$faqSearchClear.removeClass("show");
			$faqSearchClose.removeClass("show");
		}
	});

	/* - - - - - - - - - - - - - -       clear faq search input       - - - - - - - - - - - - - - - */
	$(".js-faq-search-clear").on("click", function (e) {
		e.preventDefault();
		const $faqSearchInput = $(".js-faq-search-input");
		$faqSearchInput.val("").trigger("change");
	});

	/* - - - - - - - - - - - - - -       init inputmask       - - - - - - - - - - - - - - - */
	$('[type="tel"]').inputmask("(999) 999-9999");

	/* - - - - - - - - - - - - - -      blog category position     - - - - - - - - - - - - - - - */
	function BlogCategoryPosition() {
		const $category = $(".js-blog-category");
		const $categoryWrapper = $(".js-blog-category-wrapper");
		const $cards = $(".js-blog-cards");
		const $header = $("#header");
		const headerHeight = $header.height();
		const windowHeight = document.documentElement.clientHeight;

		if ($category.is("*") && $cards.is("*")) {
			const categoryRect = $category[0].getBoundingClientRect();
			const categoryWrapperRect =
				$categoryWrapper[0].getBoundingClientRect();
			const cardsRect = $cards[0].getBoundingClientRect();
			if (categoryRect.y - headerHeight < 0) {
				$categoryWrapper.addClass("active");
				$categoryWrapper.css("position", "fixed");
				$categoryWrapper.css("left", "0");
				$categoryWrapper.css("right", "0");
				console.log(
					cardsRect.bottom - categoryWrapperRect.height - headerHeight
				);
				if (
					cardsRect.bottom -
						categoryWrapperRect.height -
						headerHeight >
					0
				) {
					$categoryWrapper.css("top", `${headerHeight}px`);
				} else {
					$categoryWrapper.css("top", `auto`);
					$categoryWrapper.css(
						"bottom",
						`${-(
							cardsRect.height -
							Math.abs(cardsRect.top) -
							windowHeight
						)}px`
					);
				}
			} else {
				$categoryWrapper.css("top", "auto");
				$categoryWrapper.css("position", "relative");
				$categoryWrapper.css("bottom", "auto");
				$categoryWrapper.removeClass("active");
			}
		}
	}
	BlogCategoryPosition();
	window.addEventListener("scroll", function () {
		BlogCategoryPosition();
	});
	window.addEventListener("resize", function () {
		BlogCategoryPosition();
	});

	/* - - - - - - - - - - - - - -       init blog slider       - - - - - - - - - - - - - - - */
	function initBlogSlider() {
		if (window.matchMedia("(min-width: 992px)").matches) {
			$(".js-blog-slider").slick({
				infinite: true,
				slidesToShow: 4,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				speed: 600,
				cssEase: "linear",
				responsive: [
					{
						breakpoint: 1240,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1,
						},
					},
				],
			});
		}
	}
	initBlogSlider();
	$(window).resize(function () {
		if (
			$(".js-blog-slider").hasClass("slick-initialized") &&
			window.matchMedia("(max-width: 991px)").matches
		) {
			$(".js-blog-slider").slick("unslick");
		} else if (!$(".js-blog-slider").hasClass("slick-initialized")) {
			initBlogSlider();
		}
	});

	/* - - - - - - - - - - - - - -      article copy box toogle     - - - - - - - - - - - - - - - */
	$(".js-article-link-copy-toogle").on("click", function (e) {
		e.preventDefault();
		const $this = $(this);
		const $parent = $this.closest(".js-article-link-copy-parent");
		const $box = $parent.find(".js-article-link-copy-box");
		if ($box.hasClass("active")) {
			$box.removeClass("active");
		} else {
			$box.addClass("active");
		}
	});

	/* - - - - - - - - - - - - - -      article copy link     - - - - - - - - - - - - - - - */
	$(".js-article-link-copy-btn").on("click", function (e) {
		e.preventDefault();
		const $this = $(this);
		const $parent = $this.closest(".js-article-link-copy-parent");
		const $copyInput = $parent.find(".js-article-link-copy-input");
		if ($copyInput.is("*")) {
			navigator.clipboard.writeText($copyInput.val());
		}
	});
});
